export const YCLIENTS_BOOKING_URL =
  'https://n43526.yclients.com/select-city/29/select-branch?o=&previousStepUrl=%2Fcompany%2F27622%2Fpersonal%2Fmenu%3Fo%3D';
